<div class="table-toolbar">

  <div *ngIf="isReadonly && relatedProductIsUpToDate">
    <button mat-icon-button color="accent" (click)="deleteElectricityMeterUnit()">
      <mat-icon>delete</mat-icon>
    </button>

    <button mat-icon-button color="accent" (click)="startEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
  

  <div *ngIf="isReadonly && !relatedProductIsUpToDate">
    <mat-slide-toggle #displayUpdatedProductsToggle
                    [checked]="displayProductUpdates"
                    (change)="onDisplayProductUpdatesChanged(displayUpdatedProductsToggle.checked)">
      <div class="slideToggleLabel">
        ÄNDERUNGEN ANZEIGEN
      </div>
    </mat-slide-toggle>

    <div *ngIf="relatedProductWasUpdated" class="display-inline-block">
      <button mat-button
              class="applyProductUpdatesButton" 
              color="accent"
              [disabled]="!displayProductUpdates"
              (click)="alignToCurrentProduct()">
        <mat-icon>done</mat-icon>
        ÄNDERUNGEN ÜBERNEHMEN
      </button>
      <mat-icon class="info-icon" 
                color="primary"
                matTooltipPosition="above"
                matTooltip="Die Artikelstammdaten haben sich geändert. Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                  sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                  Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
        info_outline
      </mat-icon>
    </div>

    <div *ngIf="relatedProductWasDeleted"  class="display-inline-block">
      <button mat-button 
              color="accent" 
              class="applyProductUpdatesButton"
              (click)="deleteElectricityMeterUnit()"
              [disabled]="!displayProductUpdates">
        <mat-icon>done</mat-icon>
        ÄNDERUNGEN ÜBERNEHMEN
      </button>
      <mat-icon class="info-icon" 
                color="primary"
                matTooltipPosition="above"
                matTooltip="Die Artikelstammdaten haben sich geändert. Diese Tabelle enthält eine Zähleranschlusssäule, die gelöscht wurde.
                Die Änderungen können durch einen Klick auf &quot;ÄNDERUNGEN ANZEIGEN&quot; 
                sichtbar gemacht und anschließend mit &quot;ÄNDERUNGEN ÜBERNEHMEN&quot; übernommen werden.
                Diese Tabelle kann erst wieder bearbeitet werden nachdem die Änderungen der Artikelstammdaten übernommen wurden.">
        info_outline
      </mat-icon>
    </div>
  </div>

  <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="discardChanges()">
    <mat-icon>clear</mat-icon>
  </button>

  <button mat-icon-button *ngIf="!isReadonly" color="accent" [disabled]="emuForm.invalid" (click)="saveChanges()">
    <mat-icon>done</mat-icon>
  </button>

  <mat-icon *ngIf="emuForm.invalid" 
            class="info-icon" 
            color="primary"
            matTooltipPosition="above"
            matTooltip="Alle Werte in der Spalte &quot;Rabatt&quot; müssen zwischen 0 und 100 liegen.">
    info_outline
  </mat-icon>

</div>

<form #emuForm="ngForm">
  <mat-table class="section-table" [dataSource]="dataSource">
    <!-- Internal Id Column -->
    <ng-container matColumnDef="productId">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Art. Nr. </mat-header-cell>
      <mat-cell *matCellDef="let entry" 
          [class.productDeleted] = "isMarkedForDeletion || (relatedProductWasDeleted && displayProductUpdates)"> 
        {{currentElectricityMeterUnit.id}}
      </mat-cell>
    </ng-container>

    <!-- Quantity Column -->
    <ng-container matColumnDef="quantity">
      <mat-header-cell *matHeaderCellDef> Menge </mat-header-cell>
      <mat-cell class="right-aligned-cell" *matCellDef="let entry; let rowIdx = index;">

        <div class="align-to-numeric-cell-input"
             [class.productDeleted] = "isMarkedForDeletion || (relatedProductWasDeleted && displayProductUpdates)">
          1
        </div>
        
      </mat-cell>
    </ng-container>

    <!-- Discount Column -->
    <ng-container matColumnDef="discountFactor">
      <mat-header-cell *matHeaderCellDef> Rabatt [%] </mat-header-cell>
      <mat-cell class="right-aligned-cell" *matCellDef="let entry; let rowIdx = index;" 
          [class.productDeleted] = "isMarkedForDeletion || (relatedProductWasDeleted && displayProductUpdates)">
        <div *ngIf="isReadonly" class="align-to-numeric-cell-input"> {{discountFactor * 100}} </div> 
        <div *ngIf="!isReadonly"> 
          <input matInput 
              #discountFactorInput="ngModel"
              name="discountFactor{{rowIdx}}"
              class="numeric-cell-input"
              [ngClass]="discountFactorInput.invalid ? 'editable-cell quantity-input invalid-value' : 'editable-cell quantity-input'"
              type="number" 
              min="0" 
              max="100" 
              step="10"
              pattern="(^100$)|(^[0-9]{1,2}$)"
              required
              [ngModel]="discountFactor * 100" 
              (ngModelChange)="onDiscountFactorChanged($event / 100)">
        </div>
      </mat-cell>
    </ng-container>

    <!-- Description Column --> 
    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Beschreibung </mat-header-cell>
      <mat-cell *matCellDef="let entry"> 
        <div *ngIf="isReadonly"
             [class.productDeleted] = "isMarkedForDeletion || (relatedProductWasDeleted && displayProductUpdates)">
          <div *ngIf="displayProductUpdates && relatedProductWasUpdated">
            {{latestProduct.name}}
          </div>
          <div [class.productOutdated] = "displayProductUpdates && relatedProductWasUpdated">
            {{currentElectricityMeterUnit.name}}
          </div>
        </div> 

        <mat-select class="product-select" *ngIf="!isReadonly" [value]="currentElectricityMeterUnit.id" (selectionChange)="onElectricityMeterUnitSelected($event.value)">
          <mat-option *ngFor="let electricityMeterUnit of electricityMeterUnits" 
                      [value]="electricityMeterUnit.id" 
                      [disabled]="isMarkedForDeletion"
                      [class.productDeleted] = "isMarkedForDeletion || (relatedProductWasDeleted && displayProductUpdates)">
            {{electricityMeterUnit.name}}
          </mat-option>
        </mat-select>
      </mat-cell>
    </ng-container>
  
    <!-- Price Per Unit Column -->
    <ng-container matColumnDef="pricePerUnit">
      <mat-header-cell [ngClass]="'right-aligned-cell'" *matHeaderCellDef mat-sort-header> Einzelpreis </mat-header-cell>
      <mat-cell class="right-aligned-cell" *matCellDef="let entry"
          [class.productDeleted] = "isMarkedForDeletion || (relatedProductWasDeleted && displayProductUpdates)">
        <div *ngIf="displayProductUpdates && relatedProductWasUpdated">
          {{latestProduct.pricePerUnit | currency}}
        </div>
        <div [class.productOutdated] = "displayProductUpdates && relatedProductWasUpdated">
          {{currentElectricityMeterUnit.pricePerUnit | currency}}
        </div>
        
      </mat-cell>
    </ng-container>

    <!-- AP Column -->
    <ng-container matColumnDef="ap">
      <mat-header-cell *matHeaderCellDef> AP </mat-header-cell>
      <mat-cell *matCellDef="let entry; let rowIdx = index;"> 
        <mat-checkbox 
          name="isAlternative{{rowIdx}}"
          [disabled]="isReadonly" 
          [ngModel]="isAlternative" 
          (ngModelChange)="onIsAlternativeChanged($event)"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Total Cost Column -->
    <ng-container matColumnDef="totalCost">
      <mat-header-cell [ngClass]="'right-aligned-cell'" *matHeaderCellDef mat-sort-header> Gesamtkosten </mat-header-cell>
      <mat-cell class="right-aligned-cell" *matCellDef="let entry"> 
        <div class="font-weight-bold" [class.ap-font] = "isAlternative">
          {{getTotalCosts() | currency}} 
        </div>
      </mat-cell>
    </ng-container>

    <!-- Delete Row Column -->
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let csSetupItem"></mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</form>